import axios from '../sda-axios'
import SDAClient from '../classes/SDAClient'
import SDAInv from '../classes/SDAInv'
import SDAStandBy from '../classes/SDAStandBy'
import config from "../sda-config";


export default {
    /**
     * Λήψη Συγκεντρωτικού Δελτίου Αποστολής (ΣΔΑ)
     * @param {string} Partner_ID - Το Partner_ID του ΣΔΑ
     * @param {string} Branch_ID - Το Branch_ID του ΣΔΑ
     * @param {string} Project_ID - Το Project_ID του ΣΔΑ
     * @returns {Promise<Object>} Το response του backend (data, Errors)
     */
    async getSDA(Partner_ID, Branch_ID, Project_ID) {

        try {

            const response = await axios.post(config.host + '/aade/getSDA', {
                Partner_ID,
                Branch_ID,
                Project_ID
            })

            if (response.data.Errors && response.data.Errors.Error_ID !== 0) {

                throw new Error(response.data.Errors.ErrorDetails || 'Unknown error occurred ')
            }

            return {
                client: new SDAClient(response.data.Data.client),
                SDAInv: new SDAInv(response.data.Data.SDAInv),
                StandBy: (response.data.Data.StandBy || []).map(item => new SDAStandBy(item)),
            }
        } catch (error) {   
            throw new Error(JSON.parse(error.response.data).Errors.ErrorDetails || 'Unknown error occurred ')
        }
    },
    /**
     * Αποστολή Συγκεντρωτικού Δελτίου Αποστολής (ΣΔΑ)
     * @param {SDAClient} sdaClient - Το client του ΣΔΑ
     * @param {Array} sdaInvItems - Τα items του ΣΔΑ
     * @returns {Promise<Object>} Το response του backend (data, Errors)
     */
    async postSDA(sdaClient, sdaInvItems, notes) {
        // Prepare payload as required
        const payload = {
            header: {
                Notes2: notes
            },
            client: {
                Partner_ID: sdaClient.Partner_ID,
                Branch_ID: sdaClient.Branch_ID,
                Project_ID: sdaClient.Project_ID,
                Store_ID: sdaClient.Store_ID,
                SDAPartnerMove_ID: sdaClient.SDAPartnerMove_ID
            },
            Items: sdaInvItems.map(({ item, value }) => ({
                PartnerMvItm_ID: item.PartnerMvItm_ID,
                Product_ID: item.Product_ID,
                Posot: value
            }))
        }
        try {
            const response = await axios.post(config.host + '/aade/postda', payload)
            return response.data
        } catch (error) {
            // If the backend returns an error response, return the error response data (if available)
            if (error.response && error.response.data) {
                console.log(error.response.data)
                return JSON.parse(error.response.data)
            }
            // Otherwise, return a generic error structure
            return {
                Data: {},
                Errors: {
                    Error_ID: 500,
                    ErrorDetails: error.message || 'Unknown error occurred'
                }
            }
        }
    },
    /**
     * Κλείνει το Συγκεντρωτικό Δελτίο Αποστολής (ΣΔΑ) χωρίς ανανέωση (DoRefresh: false).
     * @param {boolean} DoRefresh - Αν θέλουμε να γίνει ανανέωση (DoRefresh: true)
     * @returns {Promise<Object>} Το response του backend (data, Errors)
     */
    async closeSDA(DoRefresh = false) {
        try {
            const response = await axios.post(config.host + '/aade/closeSDA', { DoRefresh })
            return response.data
        } catch (error) {
            if (error.response && error.response.data) {
                return error.response.data
            }
            return {
                data: null,
                Errors: {
                    Error_ID: 500,
                    ErrorDetails: error.message || 'Unknown error occurred'
                }
            }
        }
    }
}
